import React from 'react';
import { Button } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import useStyles from './styles'

export default function MenuDebitsItem({ path, label }) {
    const classes = useStyles()
    const { pathname } = useLocation();

    const isMenuItemActive = (itemPath) => {
        return itemPath === pathname
    }

    return (
        <Link to={path} className={classes.linkGroup}>
            <Button variant="contained" className={`${isMenuItemActive(path) && classes.buttonActive} ${classes.button}`}>
                {label}
            </Button>
        </Link>
    )
}